import { ENVIRONMENT_PLACEHOLDER } from '@twaice-fe/environments/shared';

export const environment = ENVIRONMENT_PLACEHOLDER;
